import Api from './Api';

const all = (payload) => {
    const path = '/niche-categories';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const getByStatus = (payload) => {
    const path = '/niche-categories/getByStatus';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/niche-categories/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/niche-categories/update',
        method: 'PUT',
        data: payload
    });
};

const remove = (payload) => {
    return Api.deleteRequest({
        endpoint: `/niche-categories/delete/${payload.id}`,
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/niche-categories/destroy/${payload.id}`,
    });
};

export default {
    all,
    store,
    update,
    remove,
    destroy,
    getByStatus
};
